import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useId } from '@reach/auto-id';
import InputField from '../input-field';

const Field = forwardRef((props, ref) => {
  const [requiredLabelText] = useState(props.label === 'Address' ? '(required - PO boxes not accepted)' : '(required)');
  const [poBoxText] = useState(props.label === 'Street address' ? '(PO boxes not accepted)' : '');

  const isValid = () => (value) => {
    let errorMessage;

    if (
      (props.label === 'Address' || props.label === 'Street address' || props.label === 'Apt / Suite / Floor' || props.label === 'Apt, Suite, Floor, etc.')
      && !/(^(?!(?:p\W?b?o.*\d)|(?:bin)|(?:post office)).*$)/igm.test(value)
    ) {
      errorMessage = (
        <>
          Sorry, we cannot ship to p.o. boxes.
          If you believe this to be an error,
          please contact
          {' '}
          <a href="mailto:customercare@maisonette.com">customer service</a>
          .
        </>
      );
    }

    if (props.required && !value) {
      errorMessage = `${props.label} is required`;
    }

    if (props.max && value && value.length > props.max) {
      errorMessage = `${props.label} can be at most ${props.max} characters long`;
    }
  
    return errorMessage;
  };

  return (
    <>
      {props.newCheckout ? (
        <InputField
          className={props.className}
          mask={props.mask}
          permanents={props.permanents}
          mobileView={props.mobileView}
          setFieldValue={props.setFieldValue}
          ref={ref}
          label={`${props.label} ${props.required ? poBoxText : '(optional)'}`}
          name={props.name}
          id={`${props.label.toLowerCase().split(' ').join('-')}-${useId()}`}
          type={props.type}
          value={props.value}
          validate={isValid()}
          autoComplete={props.autoComplete}
          newCheckout={props.newCheckout}
          placeholder=""
          dataTestId={`${props.label.toLowerCase().split(' ').join('_')}`}
        />
      ) : (
        <InputField
          className={props.className}
          mask={props.mask}
          permanents={props.permanents}
          mobileView={props.mobileView}
          setFieldValue={props.setFieldValue}
          ref={ref}
          label={`${props.label} ${props.required ? requiredLabelText : ''}`}
          name={props.name}
          id={`${props.label.toLowerCase().split(' ').join('-')}-${useId()}`}
          placeholder={`${props.label} ${props.required ? '(required)' : ''}` || props.placeholder}
          type={props.type}
          value={props.value}
          validate={isValid()}
          autoComplete={props.autoComplete}
          dataTestId={`${props.label.toLowerCase().split(' ').join('_')}`}
        />
      )}
    </>
  );
});

Field.defaultProps = {
  className: '',
  mask: undefined,
  max: undefined,
  mobileView: false,
  permanents: undefined,
  placeholder: '',
  required: false,
  type: 'text',
  value: '',
  setFieldValue: () => { },
  newCheckout: false
};

Field.propTypes = {
  autoComplete: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  mask: PropTypes.array,
  max: PropTypes.number,
  mobileView: PropTypes.bool,
  name: PropTypes.string.isRequired,
  permanents: PropTypes.array,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  setFieldValue: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string,
  newCheckout: PropTypes.bool
};

Field.whyDidYouRender = true;

export default Field;
